// medLimitations.js — SAĞLIK SERTİFİKASI KISITLAMA KODLARI (6 Eyl 2026)
//
// 🔴 BU DOSYA SAF VERİDİR — React YOK, yan etki YOK.
//    Sebebi: `FTLEngine.js` bu tabloyu okuyor ve o motor İKİ EDGE FUNCTION'dan
//    (archive-flight, parse-plan) Deno altında da çağrılıyor. Tablo bir React
//    bileşeninin içinde kalsaydı motor React'i sunucuya sürüklerdi.
//    Aynı sebeple buradan yapılacak her import UZANTILI olmalıdır.
//
// Arayüz (AtplMedPanel) ve motor (FTLEngine) AYNI tabloyu okur — kod listesi
// ikinci kez yazılmaz (İlke 3).

/** AMC & GM to Part-MED künyesi — TEK YERDE (İlke 3). Sürüm değişirse
 *  burası değişir, on sekiz satır değil. */
export const AMC_KUNYE =
  'EASA AMC & GM to Part-MED, Issue 2, Amendment 1 — ED Decision 2025/002/R (05.02.2025)';

/** SHT-MED'in kendi Türkçe metni olan kodlarda künye ÖNCE Türkçe maddeyi
 *  gösterir. Biçim SHGM'nin kendi prosedüründen (BPR.01) alınmıştır:
 *  *"SHT MED Ek-1 MED.B.010 (d)(1)(ii) [AMC1 MED.B.010 (k)(4)(iii)]"* */
const shtRef = (bent) => `SHT-MED EK-1 [AMC2 MED.B.001(b)(${bent})] · ${AMC_KUNYE}`;
const amcRef = (bent) => `AMC2 MED.B.001(b)(${bent}) · ${AMC_KUNYE}`;

/**
 * SAĞLIK SERTİFİKASI KISITLAMA KODLARI — ONSEKİZ KOD (6 Eyl 2026).
 *
 * 🔑 Serkan: *"Medical seçince Limitation hücresi olsun, tıklayınca drop
 *    menüden her şey çıksın, çoklu seçim mümkün olsun."*
 *
 * 🔴 KODLAR NEREDEN GELİYOR — okundu, ezberden yazılmadı:
 *    Elimizdeki SHT-MED yalnız BEŞ kod yazıyor (OML/OSL/ORL/OPL/SSL). Görme,
 *    işitme ve tip kodları orada HİÇ GEÇMİYOR. Sebebi talimatın kendi hükmü:
 *      · Md.13(2) — *"Bu talimat ve Ek'inde geçmeyen hususlarda … EASA
 *        tarafından yayımlanan AMC ve GM … AYNEN KABUL EDİLİR ve UYGULANIR."*
 *      · EK-1 md.1 — Sınıf 1/2/LAPL için 1178/2011 PART-MED AMC+GM'e bakılır.
 *    Sınıf 3'ün ayrı tüzüğü (2015/340 PART ATCO-MED) olduğu için SHGM ona
 *    Türkçe kaynak doküman yazmış; Sınıf 1/2'ye YAZMAMIŞ. Bu yüzden tam tablo
 *    AMC2 MED.B.001'dedir ve Türkiye'de doğrudan uygulanır.
 *
 * ⚠️ VXL ve VXN BİLEREK YOK: metinleri *"hava trafik kontrolörünün görsel
 *    çalışma ortamı 100 cm"* diyor — Sınıf 3'e özgü, pilotta karşılığı yok.
 *
 * `ops` alanı kodun ATAMAYA etkisini söyler; motor bunu okur, kod listesini
 * ikinci kez yazmaz (İlke 3):
 *    'gate'     → atamayı ENGELLER
 *    'amber'    → engellemez, gerekçe dispatcher'ın önünde durur
 *    'validity' → sağlık geçerlilik tarihini EZER
 *    null       → pilotun kendi yükümlülüğü; atamayı değiştirmez
 */
export const MED_KISITLAMALARI = [
  // ── GÖRME ────────────────────────────────────────────────────────
  { kod:'VDL', grup:'Görme', ops:null, siniflar:null,
    ad:'Yalnızca kusurlu uzak görüşün düzeltilmesiyle geçerli — düzeltici mercek takar, yedek gözlük bulundurur',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(2),
    not:'*"Correction for defective distant vision: whilst exercising the privileges of the licence, '
      + 'the holder of the medical certificate should wear spectacles or contact lenses that correct '
      + 'for defective distant vision as examined and approved by the AeMC, AME or GMP … A spare set '
      + 'of spectacles … should be readily available."*  Pilotun kendi yükümlülüğüdür; ATAMAYI '
      + 'değiştirmez, görev kartında hatırlatma olarak görünür.' },

  { kod:'VML', grup:'Görme', ops:null, siniflar:null,
    ad:'Yalnızca kusurlu uzak, orta ve yakın görüşün düzeltilmesiyle geçerli — multifokal gözlük ve yedek',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(3),
    not:'*"Correction for defective distant, intermediate and near vision … should wear spectacles '
      + 'that correct for defective distant, intermediate and near vision … Contact lenses or full '
      + 'frame spectacles, when either correct for near vision only, may not be worn."*  Uzak ve '
      + 'yakın gözlüğü tek multifokal mercekle karşılanan durumun kodu budur.' },

  { kod:'VNL', grup:'Görme', ops:null, siniflar:null,
    ad:'Yalnızca kusurlu yakın görüşün düzeltilmesiyle geçerli — yakın gözlük hazırda ve yedek',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(4),
    not:'*"…should have readily available spectacles that correct for defective near vision as '
      + 'examined and approved by the AeMC, AME or GMP."*' },

  { kod:'CCL', grup:'Görme', ops:null, siniflar:null,
    ad:'Kusurlu uzak görüşü düzelten kontakt lens takar; benzer düzeltmeli yedek gözlük anında erişilebilir olur',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(5),
    not:'*"A spare set of similarly correcting spectacles … should be readily available for '
      + 'immediate use whilst exercising the privileges of the licence."*' },

  { kod:'VCL', grup:'Görme', ops:'gate', siniflar:[2],
    ad:'Yalnızca gündüz geçerli',
    kapsam:'Sınıf 2 ve LAPL', kaynak:amcRef(6),
    not:'*"This limitation allows holders of a class 2 or LAPL medical certificate with varying '
      + 'degrees of colour deficiency, to exercise the privileges of their licence by daytime only."*  '
      + 'ATAMA KAPISI: gece sektörü olan göreve atanamaz. Gece tayini `SolarTimes` motoruyla '
      + 'yapılır (gün doğumu −30 dk / gün batımı +30 dk).' },

  { kod:'RXO', grup:'Görme', ops:null, siniflar:null,
    ad:'Uzman oftalmolojik muayene gerektirir',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(7),
    not:'*"Specialist ophthalmological examination(s), other than the examinations stipulated in '
      + 'Part-MED, are required for a significant reason."*  İdaridir; atamayı etkilemez.' },

  // ── İŞİTME / FİZİKSEL ────────────────────────────────────────────
  { kod:'HAL', grup:'İşitme / fiziksel', ops:null, siniflar:null,
    ad:'Yalnızca onaylı işitme cihaz(lar)ı takıldığında geçerli — yedek pil hazırda',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(9),
    not:'*"…should use hearing aid(s) that compensate for defective hearing … A spare set of '
      + 'batteries should be readily available."*' },

  { kod:'APL', grup:'İşitme / fiziksel', ops:null, siniflar:null,
    ad:'Yalnızca onaylı protez ile geçerli',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(10),
    not:'*"…when a medical flight test or a flight simulator test has shown that the use of a '
      + 'prosthesis is required to safely exercise the privileges of the licence."*' },

  { kod:'AHL', grup:'İşitme / fiziksel', ops:null, siniflar:null,
    ad:'Yalnızca onaylı el kumandaları ile geçerli',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(11),
    not:'*"…to require the aircraft to be equipped with suitable, approved hand controls."*' },

  { kod:'OAL', grup:'İşitme / fiziksel', ops:'gate', siniflar:null, veri:'oal_types',
    ad:'Gösterilen hava aracı tipiyle sınırlı',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(17),
    not:'*"…had been shown by a medical flight test or flight simulator testing to be acceptable '
      + 'but to require a restriction to a specific class and type of aircraft."*  ATAMA KAPISI: '
      + 'hangi tip(ler)e izin verildiği YAZILMALIDIR — kodun tek başına anlamı yoktur.' },

  // ── OPERASYONEL ──────────────────────────────────────────────────
  { kod:'OML', grup:'Operasyonel', ops:'gate', siniflar:[1],
    ad:'Yalnızca nitelikli yardımcı pilot ile birlikte veya yardımcı pilot olarak',
    kapsam:'Sadece Sınıf 1', kaynak:shtRef(12),
    not:'SHT-MED: *"OML şerhi düşülen bir sağlık sertifikasına sahip olan kişiler sadece DİĞER '
      + 'PİLOTUN ilgili hava aracı tipinde gerekli tüm vasıflara sahip olduğu, OML\'ye tabi '
      + 'OLMADIĞI ve 60 yaşına ULAŞMADIĞI durumlarda çok pilotlu operasyonlarda bir hava aracı '
      + 'kullanabilirler."*  Bu kural ATAMA ANINDA iki pilotu birden ilgilendirir.' },

  { kod:'OCL', grup:'Operasyonel', ops:'gate', siniflar:[1],
    ad:'Yalnızca nitelikli yardımcı pilot olarak geçerli',
    kapsam:'Sadece Sınıf 1', kaynak:amcRef(13),
    not:'*"This limitation is an extension of the OML and are restricted to the role of co-pilot."*  '
      + 'OML\'den DAHA KATIDIR: OML\'li pilot kaptan koltuğunda başka nitelikli yardımcı pilotla '
      + 'uçabilirken, OCL\'li pilot YALNIZCA yardımcı pilot olabilir.' },

  { kod:'OSL', grup:'Operasyonel', ops:'gate', siniflar:[2],
    ad:'Yalnızca emniyet pilotu ile birlikte çift kumandalı hava aracında',
    kapsam:'Sınıf 2 ve LAPL', kaynak:shtRef(14),
    not:'SHT-MED — Sınıf 2 ve LAPL için. Çift kumandalı hava aracı ve kumandaları kullanabilecek '
      + 'bir koltukta oturan, sorumlu pilot vasıflarına sahip ikinci bir pilot gerekir.' },

  { kod:'OPL', grup:'Operasyonel', ops:'gate', siniflar:[2],
    ad:'Yalnızca yolcusuz geçerlidir', kapsam:'Sınıf 2 ve LAPL', kaynak:shtRef(15),
    not:'SHT-MED EK-1, operasyonel kısıtlama kodları: *"Yalnızca yolcusuz geçerlidir '
      + '(OPL - Sınıf 2 ve LAPL)."*' },

  { kod:'ORL', grup:'Operasyonel', ops:'gate', siniflar:[2],
    ad:'Yolcusuz veya bir emniyet pilotu ile birlikte geçerlidir',
    kapsam:'Sınıf 2 ve LAPL', kaynak:shtRef(16),
    not:'SHT-MED EK-1, operasyonel kısıtlama kodları: *"Yolcusuz veya bir emniyet pilotu ile '
      + 'birlikte geçerlidir (ORL - Sınıf 2 ve LAPL)."*' },

  // ── İDARİ ────────────────────────────────────────────────────────
  { kod:'TML', grup:'İdari', ops:'validity', siniflar:null, veri:'med_valid_until',
    ad:'Sağlık sertifikasının geçerliliği, sertifikada gösterilen süreyle sınırlıdır',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(1),
    not:'*"The period of validity of the medical certificate is limited to the duration as shown '
      + 'on the medical certificate. This period of validity commences on the date of the medical '
      + 'examination. Any period of validity remaining on the previous medical certificate is no '
      + 'longer valid."*  🔴 GEÇERLİLİK HESABINI EZER: TML girildiğinde MED.A.045\'ten türetilen '
      + '12/6 aylık süre KULLANILMAZ, sertifikanın kendi bitiş tarihi esas alınır.' },

  { kod:'SIC', grup:'İdari', ops:null, siniflar:null,
    ad:'Özel tıbbi muayene(ler) — temdit/yenileme öncesi AMS ile irtibat kurulmalıdır',
    kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:amcRef(8),
    not:'*"This limitation requires the AeMC, or AME to contact the medical assessor of the '
      + 'licensing authority before embarking upon a revalidation or renewal aero-medical '
      + 'assessment."*  Atamayı etkilemez ama YENİLEME daha uzun sürer — hatırlatma erken çıkar.' },

  { kod:'SSL', grup:'İdari', ops:'amber', siniflar:null, veri:'ssl_text',
    ad:'Belirtilen özel kısıtlama(lar)', kapsam:'Sınıf 1, Sınıf 2, LAPL', kaynak:shtRef(18),
    not:'*"This limitation may be considered when an individually specified limitation, not defined '
      + 'in this AMC, is appropriate … The description of the SSL should be entered on the medical '
      + 'certificate or in a separate document to be carried with the medical certificate."*  '
      + '🔑 Serkan (6 Eyl): metni sertifikanın üstünde yazdığı için SİSTEM ETKİSİNİ BİLEMEZ. '
      + 'Sessizce "sorun yok" saymak yanlış olurdu; atamayı ENGELLEMEZ ama AMBER olarak '
      + 'dispatcher\'ın önünde durur ve metni ZORUNLUDUR.' },
];

/** Bir kodun tanımı — motor ve arayüz AYNI yerden okur. */
export const kisitlama = (kod) => MED_KISITLAMALARI.find(k => k.kod === kod) || null;

/** O sağlık sınıfında SEÇİLEBİLİR kodlar. Sınıf bilinmiyorsa hepsi açıktır —
 *  boş alan "şu kod olmaz" DEMEZ (İlke 1). */
export const kisitlamaSecenekleri = (medClass) =>
  MED_KISITLAMALARI.filter(k => !k.siniflar || medClass == null || k.siniflar.includes(medClass));
